import { createClient } from "contentful";

const SPACE_ID = "drzz95kaj3fc";
const ACCESS_TOKEN =
  "3e50a3be0e014d097d8327c6c6ea6f6f4f730ebbc61f93ae32e945c9ec53e3bb";
const contentfulClient = createClient({
  space: SPACE_ID,
  accessToken: ACCESS_TOKEN
});

export default () => contentfulClient;



// WEBPACK FOOTER //
// ./src/utils/contentfulClient.js